"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _inputable = _interopRequireDefault(require("../Form/inputable"));

var _func = require("../utils/func");

var _Datum = _interopRequireDefault(require("../Datum"));

var _inputBorder = _interopRequireDefault(require("../hoc/inputBorder"));

var _styles = require("../styles");

var _Select = _interopRequireDefault(require("./Select"));

var _filter = _interopRequireDefault(require("./filter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var limitWrap = function limitWrap(Origin) {
  return function (props) {
    // eslint-disable-next-line
    var limit = props.multiple ? 0 : 1;
    return _react.default.createElement(Origin, _extends({}, props, {
      limit: limit
    }));
  };
};

var exportSelect = (0, _func.compose)(_inputable.default, (0, _inputBorder.default)({
  className: (0, _styles.selectClass)('_'),
  tag: 'div'
}), limitWrap, _Datum.default.hoc({
  bindProps: ['disabled', 'limit', 'format', 'prediction']
}), _filter.default)(_Select.default);
exportSelect.displayName = 'ShineoutSelect';
var _default = exportSelect;
exports.default = _default;